var e4 = e4 || {},
    dia = dia || {};
( function () {
    'use strict';
    jQuery( function () {
        dia.init();
    } );
    dia.init = function () {
        dia.dealersearch.init();
        dia.passwordpage.init();
    };
    dia.dealersearch = {
        options: {
            url: '/system/data/dealersearch',
            lang: jQuery( 'html' ).attr( 'lang' )
        },
        notChangedYet: true,
        init: function () {
            if ( jQuery( '#js-e-dealersearch-container' ).length === 1 ) {
                e4.require.js( e4.settings.require.handlebars, function () {
                    e4.handlebars.registerHelpers( 'compare' );
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-dealersearch #js-e-handlebars-tmpl-dealersearch-form' );
                    dia.dealersearch.bindEvents();
                    dia.dealersearch.get( true );
                } );
            }
        },
        bindEvents: function () {
            jQuery( '#js-e-dealersearch-form-container' ).on( 'input', '.js-dia-lawyer-search', e4.util.debounce( function () {
                dia.dealersearch.get();
            }, 500 ) ).on( 'change', '.js-dia-lawyer-selector', function () {
                dia.dealersearch.get();
            } );
        },
        get: function ( boolDoFormUpdate ) {
            //jQuery( '#js-e-dealersearch-container' ).find('.js-e-loading-overlay').addClass('is-loading');
            jQuery.ajax( {
                url: dia.dealersearch.options.url,
                type: 'GET',
                data: {
                    GroupID: jQuery( '.js-find-lawyer-group-name' ).val(),
                    q: jQuery( '.js-dia-lawyer-search' ).val(),
                    certified: jQuery( '.js-dia-lawyer-certified' ).val(),
                    zip: jQuery( '.js-dia-lawyer-zip-range' ).val(),
                },
                dataType: 'json'
            } )
                .done( function ( data ) {
                    dia.dealersearch.build( data );
                    if ( boolDoFormUpdate === true ) {
                        dia.dealersearch.buildForm( data );
                    }
                } )
                .fail( function ( error ) {
                    console.error( error );
                } )
                .always(function(){
                    jQuery( '#js-e-dealersearch-container' ).find('.js-e-loading-overlay').removeClass('is-loading');
                });
        },
        buildForm: function ( data ) {
            var jContainer = jQuery( '#js-e-dealersearch-form-container' );
            jContainer.html( e4.handlebars.tmpl.dealersearchForm( data ) );
        },
        build: function ( data ) {
            var jContainer = jQuery( '#js-e-dealersearch-container' );
            if ( data.q ) {
                data.dealers = dia.dealersearch.sortDealersByRelevans( data.dealers, data.q );
            }

            jContainer.html( e4.handlebars.tmpl.dealersearch( data ) );
        },
        sortDealersByRelevans: function ( arrDealers, strQuery ) {
            var arrMatches = [],
                arrNoMatches = [];
            for ( var i = 0; i < arrDealers.length; i++ ) {
                var strFirstname = arrDealers[ i ].firstname.value.toLowerCase();

                if ( strFirstname.indexOf( strQuery.toLowerCase() ) === 0 ) {
                    arrMatches.push( arrDealers[ i ] );
                }
                else {
                    arrNoMatches.push( arrDealers[ i ] );
                }
            }
            return ( arrMatches.concat( arrNoMatches ) );
        }
    };
    dia.passwordpage = {
        init: function () {
            dia.passwordpage.errorMsg();
        },
        errorMsg: function () {
            jQuery( 'form[name="ExtUserForm"]' ).on( 'submit', function ( event ) {
                jQuery.ajax( {
                    data: jQuery( event.target ).serialize()
                } ).done( function ( html ) {
                    if ( jQuery( html ).find( 'input[name="Password"]' ).length === 0 ) {
                        jQuery('.js-dia-password-form-input-error_Password').addClass('d-none');
                        jQuery( 'input[name="Password"]' ).removeClass('error');
                        location.reload();
                    }
                    else {
                        console.log('error');
                        jQuery('.js-dia-password-form-input-error_Password').removeClass('d-none');
                        jQuery( 'input[name="Password"]' ).addClass('error');
                    }
                } );
                event.preventDefault();
            } );
        }
    };
}() );

